import api from './client';

export const warehouseApi = {
  listJobs: () => api.get('/warehouse/jobs').then((r) => r.data),
  getJob: (jobId: string) => api.get(`/warehouse/jobs/${jobId}`).then((r) => r.data),

  // override: true bypasses the out-of-date electrical-test block (logged in audit).
  scanOut: (jobId: string, assetId: string, override?: boolean) =>
    api.post(`/warehouse/jobs/${jobId}/scan-out`, { assetId, override }).then((r) => r.data),
  scanIn: (jobId: string, assetId: string) =>
    api.post(`/warehouse/jobs/${jobId}/scan-in`, { assetId }).then((r) => r.data),
  freeScan: (jobId: string, assetId: string, override?: boolean) =>
    api.post(`/warehouse/jobs/${jobId}/free-scan`, { assetId, override }).then((r) => r.data),

  bulkConfirm: (jobId: string, data: { inventoryItemId?: string | null; quoteLineItemId: string; quantity: number }) =>
    api.post(`/warehouse/jobs/${jobId}/bulk-confirm`, data).then((r) => r.data),
  bulkReturn: (jobId: string, data: { quoteLineItemId: string; quantity: number }) =>
    api.post(`/warehouse/jobs/${jobId}/bulk-return`, data).then((r) => r.data),
  bulkRescanOut: (jobId: string, quoteLineItemId: string) =>
    api.post(`/warehouse/jobs/${jobId}/bulk-rescanout`, { quoteLineItemId }).then((r) => r.data),

  // Sales dispatch checklist — absolute delivered total for a sales line (0 = undo).
  deliver: (jobId: string, quoteLineItemId: string, deliveredQuantity: number) =>
    api.post<{ line: { id: string; deliveredQuantity: number; deliveredAt: string | null; deliveredBy: string | null }; jobStatus: string }>(
      `/warehouse/jobs/${jobId}/deliver`, { quoteLineItemId, deliveredQuantity },
    ).then((r) => r.data),

  // Persist an attached-accessory "packed" tick (clamps, safeties).
  setAccessoryPack: (jobId: string, itemAccessoryId: string, packed: boolean) =>
    api.post(`/warehouse/jobs/${jobId}/accessory-pack`, { itemAccessoryId, packed }).then((r) => r.data),

  transfer: (jobId: string, assetId: string, targetJobId: string) =>
    api.post(`/warehouse/jobs/${jobId}/transfer`, { assetId, targetJobId }).then((r) => r.data),

  markDamaged: (jobId: string, assetId: string, notes: string) =>
    api.post(`/warehouse/jobs/${jobId}/mark-damaged`, { assetId, notes }).then((r) => r.data),

  outstanding: () => api.get('/warehouse/outstanding').then((r) => r.data),

  markMissingTracked: (jobId: string, assetId: string, notes?: string) =>
    api.post(`/warehouse/jobs/${jobId}/mark-missing`, { kind: 'tracked', assetId, notes }).then((r) => r.data),
  markMissingBulk: (jobId: string, quoteLineItemId: string, quantity: number, notes?: string) =>
    api.post(`/warehouse/jobs/${jobId}/mark-missing`, { kind: 'bulk', quoteLineItemId, quantity, notes }).then((r) => r.data),

  markFound: (assetId: string) =>
    api.post(`/warehouse/units/${encodeURIComponent(assetId)}/mark-found`, {}).then((r) => r.data),

  auditLog: (jobId: string) => api.get(`/warehouse/jobs/${jobId}/audit-log`).then((r) => r.data),
  overdue: () => api.get('/warehouse/overdue').then((r) => r.data),
};
